import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import PageWrapper from "../../../../components/layout/page/PageWrapper";
import PageHeader from "../../../../components/layout/page/PageHeader";
import ViewContainer from "../../../../components/layout/view/ViewContainer";

import StatusAlert from "../../../../components/alerts/StatusAlert";

import { useProfile } from "../hooks/useProfile";

import {
  PersonalDetailsForm,
  SecurityForm,
  DangerZoneForm,
} from "../components/AccountForm";

import "./AccountPage.css";

export default function MemberAccountPage() {
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");

  const {
    profile,
    loading,
    error,
    setProfile,
    handleUpdatePersonalDetails,
    handlePasswordUpdate,
    handleDeleteAccount,
  } = useProfile();

  useEffect(() => {
    document.title = "Katch | Account Settings";
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setProfile((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleSecuritySave = async () => {
    if (!newPassword.trim() || loading) return;

    const result = await handlePasswordUpdate(newPassword);

    if (result !== false) {
      setNewPassword("");
    }
  };

  return (
    <PageWrapper size="md">
      <PageHeader
        title="Account Settings"
        description="Manage your personal information and account security."
      />

      <ViewContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 24,
            width: "100%",
          }}
        >
          {error?.message && <StatusAlert status={error} />}

          <PersonalDetailsForm
            profile={profile}
            onChange={handleInputChange}
            onSave={handleUpdatePersonalDetails}
            loading={loading}
          />

          <SecurityForm
            profile={profile}
            password={newPassword}
            setPassword={setNewPassword}
            onSave={handleSecuritySave}
            loading={loading}
          />

          <DangerZoneForm
            onDelete={() => handleDeleteAccount(navigate)}
            loading={loading}
          />
        </div>
      </ViewContainer>
    </PageWrapper>
  );
}
